import { RouteMap } from 'constants/Routes';

const allRoutes = Object.values(RouteMap).map((route) => route.path);

export default (slug: string) => {
  if (allRoutes.includes(slug)) {
    return slug;
  }

  const slugs = slug.split('/');
  const slugLength = slugs.length - 1;

  if (slugLength === 1) {
    return {
      as: slug,
      href: RouteMap.GENERIC.path,
    };
  }

  if (slugs[1] === 'writers') {
    return {
      as: slug,
      href: RouteMap.AUTHOR.path,
    };
  }
  if (slugs[1] === 'learn' && slugs.length > 2) {
    return {
      as: slug,
      href: RouteMap.TOPICS.path,
    };
  }

  return slug;
};
